import type { CampaignModel } from '@models/types'

import CampaignQuoteEditRoutes from './routes'

type CampaignQuoteEditProps = {
  campaign: CampaignModel,
}

const CampaignQuoteEdit = (props: CampaignQuoteEditProps) => {
  const { campaign } = props

  return (
    <CampaignQuoteEditRoutes campaign={campaign} />
  )
}

export default CampaignQuoteEdit
